<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
<!-- Error Section -->
<div *ngIf="error" class="w-full flex items-center justify-center">
    <app-error-page></app-error-page>

</div>
<div *ngIf="!cancelDone && (!error) && !loading" class="flex flex-col justify-center items-center w-full  bg-gray-100 p-6">
    <div class="bg-white shadow-lg rounded-lg p-6">
        <h2 class="text-2xl font-semibold text-gray-900 text-center mb-4">Cancel Booking</h2>
            <fuse-alert [type]="'info'" [appearance]="'outline'" class="drop-shadow select-none my-3">
                <b>Info: </b> Please review booking details before canceling. Once canceled, this action cannot be undone.
            </fuse-alert>
        <!-- <div class="p-4 mb-4 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
            <span class="font-medium">Info alert!</span>  
          </div> -->

        <!-- Client Information -->
        <div class="space-y-4 border-b pb-4">
            <div class="flex items-center space-x-3">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:user"
                    matTooltip="Client Name"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium">Client Name</div>
                    <div class="text-gray-500 text-sm">
                        {{this.bookingData.client_first_name}} &nbsp; {{this.bookingData.client_last_name}}
                    </div>
                </div>
            </div>

            <div class="flex items-center space-x-3">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:envelope"
                    matTooltip="Email Address"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium">Client Email</div>
                    <div class="text-gray-500 text-sm">
                        {{this.bookingData.client_email}}
                    </div>
                </div>
            </div>
        </div>

        <!-- Booking Details -->
        <div class="space-y-4 border-b pb-4 mt-4">
            <div class="flex items-center space-x-3">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:clock"
                    matTooltip="Booking Duration"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium">Booking Duration</div>
                    <div class="text-gray-500 text-sm"> {{this.bookingData.duration}} Minutes</div>
                </div>
            </div>

            <div class="flex items-center space-x-3">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:calendar"
                    matTooltip="Booking Date"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium">Booking Date</div>
                    <div class="text-gray-500 text-sm"> {{this.bookingData.appointment_start_time | date:'MMM dd, h:mm a'}}</div>
                </div>
            </div>
        </div>

        <!-- Cancellation Confirmation -->
        <p class="  text-primary text-center text-lg mt-6">
            Are you sure you want to cancel this booking?  
            The participants will be notified, and the booking slot will be reopened.
        </p>

        <div class="mt-6 flex justify-between">
            <button mat-button 
                class="px-4 py-2 bg-red-500 text-white hover:bg-red-600 transition rounded-md"
                (click)="openDialog(modalTemplate)">Yes, Cancel</button>
        </div>
    </div>
</div>

<div *ngIf="cancelDone && (!error) && !loading" class="flex flex-col justify-center items-center w-full  bg-gray-100 p-6">
    <div class="bg-white shadow-lg rounded-lg p-6">
        <div class="text-center space-y-2 mt-6">
            <p class="text-lg text-gray-700">
                Your booking has been canceled.
            </p>
            <p class="text-lg text-gray-700">
                Click below button to schedule new booking.
            </p>
        </div>
        <div class="w-full flex justify-center py-3 px-2">
          <button  (click)="loadBookingPage()" mat-raised-button
          color="primary" class="" type="submit">
          Schedule another booking
      </button>
        </div>
    </div>
</div>
<ng-template #modalTemplate let-data>
    <div class="">
      <h2 class=" text-lg border-b mb-2 text-primary-500  py-2">Booking Cancellation</h2>
      <mat-dialog-content>
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Notes</mat-label>
            <textarea matInput rows="3" name="content" [(ngModel)]="cancelBookingPayload.content"></textarea>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions class="flex justify-end w-full">
        <button mat-stroked-button color="warn" (click)="dialogRef.close()" matTooltip="close"
        class="button-inner-icon mr-4">
        Close
      </button>

      <button mat-stroked-button color="primary" (click)="cancelBooking()" matTooltip="Cancel Booking"
        class="button-inner-icon mr-4">
        Cancel Booking
      </button>
      </mat-dialog-actions>
    </div>

  </ng-template>
